'use client'

import { sendGTMEvent } from '@next/third-parties/google'
import { useEffect, useRef } from 'react'

export default function StoryViewTracker({ storySlug, category, userType }) {
  const hasTracked = useRef(false)

  useEffect(() => {
    if (hasTracked.current) return
    hasTracked.current = true

    sendGTMEvent({
      event: 'story_view',
      story_slug: storySlug,
      category: category,
      user_type: userType,
    })
  }, [storySlug, category, userType])

  return null
}
